// extracted by mini-css-extract-plugin
export default {"error":"Home_error__szGrz","home":"Home_home__9Ke73"};